import React from 'react';

import { useProps, useClassName } from 'components/pure/hooks';
import { cn } from 'twyne-new.ui';

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: '',
}

export default function Dropzone({ className, render, ...props }) {
  className = useClassName(classNames, className)

  return <div {...useProps(props, imutableProps)} className={className}>
    <div className={cn('p-4 w-full flex items-center justify-center twy-bg-base rounded-sm text-sm text-[10px]!', !render ? 'twy-bg-base-accent' : '')}>
      {render ? 'Drag and drop a field here to create a new step.' : ''}
    </div>
  </div>
}

Dropzone.propTypes = propTypes
Dropzone.defaultProps = mutableProps
